"use client";

// src/components/atoms/Image/Image.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var CLOUDINARY_BASE_URL = "https://res.cloudinary.com/dunz5zfpt/";
var Image = ({
  src,
  alt,
  srcSet,
  width,
  height,
  className,
  layout
}) => {
  const getFullUrl = (src2) => {
    if (src2.startsWith("https://res.cloudinary.com")) {
      return src2;
    }
    return `${CLOUDINARY_BASE_URL}${src2}`;
  };
  return /* @__PURE__ */ jsxs("picture", { children: [
    srcSet && srcSet.map((set, index) => /* @__PURE__ */ jsx(
      "source",
      {
        media: set.media,
        srcSet: getFullUrl(set.srcSet),
        type: set.type
      },
      index
    )),
    /* @__PURE__ */ jsx(
      "img",
      {
        src: getFullUrl(src),
        alt,
        width: width != null ? width : void 0,
        height: height != null ? height : void 0,
        className: `${className != null ? className : ""} ${layout === "fill" ? "absolute inset-0 w-full h-full object-cover" : ""}`
      }
    )
  ] });
};
var Image_default = Image;

export {
  Image_default
};
